// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Q8-z","fadeIn":"R8-z","delay":"S8-z","recommendedSizeTooltip":"T8-z"};